import Close from './icons/close.svg?react'
import Context from './icons/context.svg?react'
import Coverage from './icons/coverage.svg?react'
import Home from './icons/home.svg?react'
import Search from './icons/search.svg?react'
import Star from './icons/star.svg?react'
import StarFilled from './icons/star-filled.svg?react'
import Summary from './icons/summary.svg?react'

export const Icons = {
  Close,
  Context,
  Coverage,
  Home,
  Search,
  Star,
  StarFilled,
  Summary
}
